import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reject-angle",
  "use": "icon-reject-angle-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"icon-reject-angle\"><path data-name=\"路径 260\" d=\"M64 0H8.649A8.649 8.649 0 000 8.649V64z\" fill=\"#f34686\" /><path data-name=\"路径 708\" d=\"M10.515 27.486a12 12 0 100-16.971 12 12 0 000 16.971zm15.154-1.817a9.436 9.436 0 01-12.42.8l13.217-13.22a9.436 9.436 0 01-.797 12.42zM12.332 12.332a9.436 9.436 0 0112.42-.8l-13.217 13.22a9.436 9.436 0 01.797-12.42z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol